export const HEADER_SCROLL_OFFSET = -70
